import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GenericConfirmDialogComponent } from '../../views/configuration/admin-users/generic-confirm-dialog/generic-confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationService {

  constructor(private modalService: BsModalService) {}

  public confirm(title?: string, message?: string, btnOkText?: string, btnCancelText?: string): Promise<boolean> {
    let initialState: Partial<GenericConfirmDialogComponent>;
    title && (initialState.title = title);
    message && (initialState.message = message);
    btnOkText && (initialState.btnOkText = btnOkText);
    btnCancelText && (initialState.btnCancelText = btnCancelText);

    const modalRef: BsModalRef = this.modalService.show(GenericConfirmDialogComponent, {
      initialState,
      ignoreBackdropClick: true
    });

    return new Promise<boolean>((resolve) => {
      const confirmDialog = modalRef.content as GenericConfirmDialogComponent;
      confirmDialog.setConfirmationHandler(resolve);
    });
  }
}
